import axios, { AxiosInstance } from "axios";
import { IEdocsCodeData, IEdocsSignData, InfoData, IUploadFileData } from "./RequestsData";
import { IUserInfo, IRequiredDoc, IFiasAdress, ICoworkersInfo, ICommunityShort, CardData, IRecruitmentDateSlotResponse, IOfferData, ICommunityFull, IOfferShort, } from "./ResponseData";

//const serviceUrl = "http://localhost:51798/api";
//const serviceUrl = "http://msa-corpr1-ap1:3008/api";
const serviceUrl = "https://onboard.finam.ru/api";


export class WebService {
    private readonly axiosInstance: AxiosInstance;

    constructor(token: string) {
        this.axiosInstance = axios.create({
            withCredentials: true,
        });
        this.axiosInstance.interceptors.request.use(function (config) {
            if (!config) {
                config = {};
            }
            if (!config.headers) {
                config.headers = {};
            }
            config.headers.Authorization = token;
            return config;
        });
    }

    public async GetUserData(): Promise<{ userName: string, stepNumber: number, success: boolean, exception: string, requestData: InfoData, isClient: boolean }> {
        var request = await this.axiosInstance.get(serviceUrl + "/sharepoint/auth?step=4");
        return request.data;
    }

    public async GetNewUNEP(): Promise<any> {
        var request = await this.axiosInstance.post(serviceUrl + "/kadry/getUnep");
        return request.data;
    }

    public async GetUNEPStatus(): Promise<{ document: { id: number, title: string, docType: number }, unepStatus: number, message: string }> {
        var request = await this.axiosInstance.get(serviceUrl + "/kadry/unepStatus");
        return request.data;
    }

    public async GetUserInfo(guid: string): Promise<{ result: IUserInfo }> {
        var request = await this.axiosInstance.get(serviceUrl + "/sharepoint/userinfo", { params: { guid } });
        return request.data;
    }

    public async PostFileInfo(filesData: IUploadFileData): Promise<any> {
        var request = await this.axiosInstance.post(serviceUrl + "/kadry/uploadDoc", filesData);
        return request.data;
    }

    public async GetPersonalDocuments(nnDocType?: number): Promise<IRequiredDoc[]> {
        var request = await this.axiosInstance.get(serviceUrl + "/kadry/persDocs", { params: { nnDocType } });
        return request.data;
    }

    public async SignUNEPDocuments(requestData: IEdocsSignData): Promise<{ phones: string, confirmId: string }> {
        var request = await this.axiosInstance.post(serviceUrl + "/edocs/sign", requestData);
        return request.data;
    }

    public async GetSigningDocs(): Promise<{ nnDoc: number, strDocType: string, nnDocType: number, isSigned: boolean }[]> {
        var request = await this.axiosInstance.get(serviceUrl + "/kadry/getSignDocuments");
        return request.data;
    }

    public async SendCodeUNEPDocuments(requestData: IEdocsCodeData): Promise<any> {
        var request = await this.axiosInstance.post(serviceUrl + "/edocs/code", requestData);
        return request.data;
    }

    public async DownloadDocument(docId: number, fileId: number): Promise<any> {
        var request = await this.axiosInstance.get(serviceUrl + "/edocs/download", { params: { docId, fileId } });
        return request.data;
    }

    public async GetInnerDocuments(): Promise<any> {
        var request = await this.axiosInstance.get(serviceUrl + "/sharepoint/innerDocuments");
        return request.data;
    }


    public async GetFiasAdressList(level: number, parentLevel: number, parentGuid?: string): Promise<IFiasAdress[]> {
        var request = await this.axiosInstance.get(serviceUrl + "/FIAS/adressList", { params: { level, parentLevel, parentGuid } });
        return request.data || [];
    }

    public async SaveFiasAdress(addressType: number, adress: IFiasAdress[]): Promise<any> {
        var request = await this.axiosInstance.post(serviceUrl + "/FIAS/saveAdress", { addressType, adress });
        return request.data;
    }

    public async GetFiasAdress(addressType: number): Promise<any> {
        var request = await this.axiosInstance.get(serviceUrl + "/FIAS/adress", { params: { addressType } });
        return request.data;
    }

    public async GetBanks(): Promise<{ bankId: number, bic: string, bankName: string, bankFullName: string }[]> {
        var request = await this.axiosInstance.get(serviceUrl + "/kadry/banksList");
        return request.data;
    }

    public async SaveCard(bankId: number, accNum: string): Promise<any> {
        var request = await this.axiosInstance.post(serviceUrl + "/kadry/card", { bankId, accNum });
        return request.data;
    }

    public async GetCard(): Promise<CardData> {
        var request = await this.axiosInstance.get(serviceUrl + "/kadry/card");
        return request.data;
    }

    public async GetPhoto(): Promise<string> {
        var request = await this.axiosInstance.get(serviceUrl + "/kadry/myphoto");
        return request.data;
    }

    public async GetCoworkers(): Promise<ICoworkersInfo[]> {
        var request = await this.axiosInstance.get(serviceUrl + "/sharepoint/coworkers");
        return request.data;
    }

    public async UploadPhoto(file: File): Promise<any> {
        var bodyFormData = new FormData();
        bodyFormData.append("image", file);
        var request = await this.axiosInstance.post(serviceUrl + "/kadry/uploadPhoto", bodyFormData, { headers: { "Content-Type": "multipart/form-data" } });
        return request.data;
    }

    public async GetCommunities(): Promise<ICommunityShort[]> {
        var request = await this.axiosInstance.get(serviceUrl + "/sharepoint/communities");
        return request.data;
    }

    public async GetOffers(): Promise<IOfferShort[]> {
        var request = await this.axiosInstance.get(serviceUrl + "/sharepoint/offers");
        return request.data;
    }

    public async GetCommunity(id: number): Promise<ICommunityFull> {
        var request = await this.axiosInstance.get(serviceUrl + "/sharepoint/community", { params: { id } });
        return request.data;
    }

    public async GetFreeSlots(): Promise<IRecruitmentDateSlotResponse[]> {
        var request = await this.axiosInstance.get(serviceUrl + "/offer/freeSlots");
        return request.data;
    }

    public async GetSlot(slotId: number): Promise<IRecruitmentDateSlotResponse> {
        var request = await this.axiosInstance.get(serviceUrl + "/offer/slot", { params: { slotId } });
        return request.data;
    }

    public async SelectSlot(slotId: number): Promise<any> {
        var request = await this.axiosInstance.post(serviceUrl + "/offer/selectSlot", { slotId });
        return request.data;
    }

    public async GetOffer(): Promise<IOfferData> {
        var request = await this.axiosInstance.get(serviceUrl + "/offer/offer");
        return request.data;
    }

    public async AcceptOffer(decision: boolean, comment: string): Promise<IOfferData> {
        var request = await this.axiosInstance.post(serviceUrl + "/offer/offer", { decision, comment });
        return request.data;
    }
}







